<p-card
  styleClass="very-compact-card"
  header="История изменений">
  <div class="px-3 pb-3">
    <div
      *ngIf="historyItems?.length; else notData"
      class="overflow-y-auto"
      (scroll)="onScrollEndHistory($any($event.target))"
      style="height: 300px">
      <crm-spinner *ngIf="loadingHistory"></crm-spinner>
      <ng-container *ngIf="!loadingHistory">
        <div
          *ngFor="let history of historyItems"
          class="px-1 py-2">
          <div class="text-400 text-sm">{{ history?.created | date: 'dd MMMM yyyy HH:mm' }}</div>
          <a
            *ngIf="history?.user"
            routerLink="/user/card/{{ history?.user?.id }}"
            target="_blank">
            {{ history?.user?.profile?.name }}
          </a>
          <p>{{ history?.fieldName }}: c "{{ history?.oldFieldValue }}" на "{{ history?.newFieldValue }}"</p>
        </div>
        <div
          *ngIf="paginationLoadingHistory"
          class="text-center">
          <p-progressSpinner
            [style]="{
              width: '50px',
              height: '50px'
            }"></p-progressSpinner>
        </div>
      </ng-container>
    </div>
    <ng-template #notData>
      <p class="text-xl font-medium ml-1">Нет данных</p>
    </ng-template>
  </div>
</p-card>
